// components
import { CareHomeShortlist } from '@karehero/models';

import { CareHomeOverview } from '@/components/organisms';

export const CareSearch = ({
  shortlist,
  shortlistData,
  onMarkSecured,
}: CareSearchProps) => {
  return (
    <CareHomeOverview
      shortlist={shortlist}
      shortlistData={shortlistData}
      onMarkSecured={onMarkSecured}
    />
  );
};

interface CareSearchProps {
  shortlist: CareHomeShortlist;
  shortlistData: any;
  onMarkSecured?: (regulatoryID: string) => void;
}

CareSearch.displayName = 'CareSearch';

export default CareSearch;
